import * as React from "react";
const DistributeFullWidth = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 10H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Zm1-5V4H4v1h17ZM5 9h15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2Zm16 11v1H4v-1h17Z" }));
DistributeFullWidth.displayName = "DistributeFullWidth";
var DistributeFullWidth_default = DistributeFullWidth;
export {
  DistributeFullWidth_default as default
};
